export const getClassForCell = (cell, isCached = false) => {
    if (cell == null || cell == undefined) {
        return {'arva-alert': true};
    }

    if(isCached === true)
        return {'pre-gen':true}

    return {
        'arva-alert': cell == null,
        'pre-gen': cell.source !== 'User Input' && cell.source !== 'shapefile' && cell.value !== null,
        machine: cell.source == 'shapefile' && cell.value !== null,
        // complete: cell.source == 'User Input' && cell.value !== null,
        complete: cell !== null && isCached === false,
    };
}
